export default __webpack_public_path__ + "static/media/41.c6a69452.jpg";